<template>
  <!--该页面内容高度为父容器的100%，不允许出现垂直方向的滚动条-->
  <div class="live-video container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="false" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入视频节点名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        :class="controlTabsOpen ? 'control-tabs-visible':''"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
        @node-contextmenu="handleTreeNodeContextMenu"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"
               :class="data.type === 'region' ? 'tree-node-icon-region'
               : streamNodeIconClassFromStreamObjectKindAndState(data.streamObjectKind, data.alarmState, data.eventTypeSet, data.workState)"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
      <el-tabs v-model="activeTabName" v-show="controlTabsOpen">
        <el-tab-pane label="云台控制" name="0">
          <div class="ptz-control">
            <div class="ptz-control-left">
              <ul class="direction-list">
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_UP)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_UP)"><i
                  class="iconfont icon-top"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_RIGHTUP)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_RIGHTUP)">
                  <i class="iconfont icon-right-top"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_RIGHT)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_RIGHT)"><i
                  class="iconfont icon-right-arrow"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_RIGHTDOWN)"
                    @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_RIGHTDOWN)"><i class="iconfont icon-right-bottom"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_DOWN)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_DOWN)"><i
                  class="iconfont icon-bottom"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_LEFTDOWN)"
                    @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_LEFTDOWN)"><i class="iconfont icon-left-bottom"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_LEFT)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_LEFT)"><i
                  class="iconfont icon-left-arrow"></i></li>
                <li @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_MOVE_LEFTUP)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_LEFTUP)"><i
                  class="iconfont icon-left-top"></i></li>
              </ul>
            </div>
            <div class="ptz-control-right">
              <ul class="control-btn-list">
                <li class="control-btn-list-item">
                  <div class="control-btn-title">变倍</div>
                  <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_ZOOM_IN)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_ZOOM_IN)"
                       class="control-btn danbei-btn"></div>
                  <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_ZOOM_OUT)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_ZOOM_OUT)"
                       class="control-btn duobei-btn"></div>
                </li>
                <li class="control-btn-list-item">
                  <div class="control-btn-title">光圈</div>
                  <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_INCREASE)"
                       @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_STOP_INCREASE)" class="control-btn dagq-btn"></div>
                  <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_DECREASE)"
                       @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_APERTURE_STOP_DECREASE)" class="control-btn xiaogq-btn"></div>
                </li>
                <li class="control-btn-list-item">
                  <div class="control-btn-title">聚焦</div>
                  <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_FOCUS_OUT)"
                       @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_FOCUS_OUT)" class="control-btn jujiao1-btn"></div>
                  <div @mousedown="ptzControl($type.ptzCommands.DVR_PTZ_FOCUS_IN)" @mouseup="ptzControl($type.ptzCommands.DVR_PTZ_STOP_FOCUS_IN)"
                       class="control-btn jujiao2-btn"></div>
                </li>
              </ul>
            </div>
          </div>
          <div class="ptz-control-speed">
            <div class="ptz-control-speed-title">云台速度</div>
            <div class="ptz-control-speed-slider">
              <el-slider v-model="hSpeed" :min="1" :max="10"></el-slider>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="预置点控制" name="1">
          <div class="preset-control">
            <div class="preset-control-bar">
              <el-button class="col-btn" type="text" icon="el-icon-place" @click="presetControl($type.ptzCommands.DVR_PTZ_MOVE_PRESET)">调用</el-button>
              <el-button class="col-btn" type="text" icon="el-icon-edit" @click="presetControl($type.ptzCommands.DVR_PTZ_SET_PRESET)">添加</el-button>
              <el-button class="col-btn" type="text" icon="el-icon-delete" @click="presetControl($type.ptzCommands.DVR_PTZ_DEL_PRESET)">删除</el-button>
            </div>
            <el-table ref="presetInfoTable"
                      :data="presetInfoTableData"
                      border highlight-current-row
                      style="width: 100%"
                      v-loading="presetInfoLoading"
                      element-loading-text="努力加载中..."
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(255, 255, 255, 0.8)"
                      @current-change="handlePresetInfoTableCurrentChange">
              <el-table-column label="序号" type="index" width="60"></el-table-column>
              <el-table-column label="名称" prop="name"></el-table-column>
              <el-table-column label="点号" prop="presetNum" width="80"></el-table-column>
            </el-table>
            <el-pagination
              small
              @current-change="handlePresetInfoCurrentPageChange"
              :current-page.sync="presetInfoTableQueryParams.pageNum"
              :page-size.sync="presetInfoTableQueryParams.pageSize"
              layout="total, prev, pager, next"
              :total="presetInfoTableTotalRow">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="图像参数" name="2">
          <div class="vieo-param-control">
            <div class="vieo-param-item">
              <div class="name">亮度：{{videoParam.ld}}</div>
              <el-slider class="vieo-param-slider" v-model="videoParam.ld" :min="0" :max="255"></el-slider>
            </div>
            <div class="vieo-param-item">
              <div class="name">对比度：{{videoParam.db}}</div>
              <el-slider class="vieo-param-slider" v-model="videoParam.db" :min="0" :max="255"></el-slider>
            </div>
            <div class="vieo-param-item">
              <div class="name">饱和度：{{videoParam.bh}}</div>
              <el-slider class="vieo-param-slider" v-model="videoParam.bh" :min="0" :max="255"></el-slider>
            </div>
            <div class="vieo-param-item">
              <div class="name">色度：{{videoParam.sd}}</div>
              <el-slider class="vieo-param-slider" v-model="videoParam.sd" :min="0" :max="255"></el-slider>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </app-tree-side>
    <!--右侧内容-->
    <div class="col-2">
      <div class="video-list" ref="videoList" :style="{height: !footerOpen ? '100%' : ''}">
        <div class="video-item"
             v-for="(item, index) in players"
             :class="[isSingle ? 'single-video-item' : '', item.id === currentVideoPlayerId ? 'video-item-active' : '']"
             v-show="!isSingle || (isSingle && (currentVideoPlayerId !== 0 && item.id === currentVideoPlayerId) || (currentVideoPlayerId === 0 && index === 0)) "
             :key="'videoItem' + index"
             ref="videoItem"
             @click="item.active ? selectVideoPlayer(item) : ''"
        >
          <div class="video-item-title" v-show="tileVisible">
            <div class="video-item-title-left">{{ item.active ? item.streamNodeName : item.title }}</div>
<!--            <div class="video-item-title-right" v-if="item.active">-->
            <div class="video-item-title-right">
              <a @click="capturePictureJpeg()" href="javascript:;" class="video-item-btn camera-btn"></a>
              <!--<a href="javascript:;" class="video-item-btn save-btn"></a>-->
              <a @click="stopVideo(item.streamNodeId)" href="javascript:;" class="video-item-btn close-btn"></a>
            </div>
          </div>
          <div class="video-item-content" :class="[tileVisible ? '':'video-item-title-hide',$globalConfig.playerBackgroundStyle === 0 ? '':'black-style'] " ref="videoPlayerContainer">
            <!--视频控件-->
            <video :id="'video-player' + String(index + 1)" ref="videoPlayer" class="video-player" v-show="item.active" controls autplayerParamslay></video>
          </div>
        </div>
      </div>
      <div class="video-control-bar" :class="!footerOpen ? 'video-control-bar-side-close' : ''">
        <div class="video-control-bar-toggle-btn" @click="toggleFooter"></div>
        <div class="video-control-bar-left">
          <a @click="singleLayout" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon single_view"></span>单画面
          </a>
          <a @click="fourLayout" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon more_view"></span>四画面
          </a>
          <a @click="videoBrowserFullScreen" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon el-icon-full-screen" style="font-size: 30px"></span>全屏
          </a>
          <a @click="switchTitleVisible" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon el-icon-postcard" style="font-size: 30px"></span>标题
          </a>
        </div>
        <div class="video-control-bar-right">
          <a @click="capturePictureJpeg" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon snap_view"></span>抓拍
          </a>
          <!--<a href="javascript:;" class="video-control-bar-control-btn">-->
          <!--<span class="view_icon record_view"></span>录像-->
          <!--</a>-->
          <a @click="handleModifyVideoPatrol" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon turning_view"></span>轮巡
          </a>
          <a @click="stopVideo(currentStreamNodeId)" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon turn_off_view"></span>关闭视频
          </a>
          <a @click="stopAllVideo" href="javascript:;" class="video-control-bar-control-btn">
            <span class="view_icon turn_off_all_view"></span>关闭全部
          </a>
        </div>
      </div>
    </div>

    <!--修改视频轮巡-->
    <modify-video-patrol v-if="videoPatrolModalOpen"  :modalOpen="videoPatrolModalOpen" :videoPatrolActive="videoPatrolActive" @startVideoPatrol="handleStartVideoPatrol"
                         @stopVideoPatrol="handleStopVideoPatrol" @closeVideoPatrolModal="handleModalCancel"></modify-video-patrol>
  </div>
</template>

<script type="text/ecmascript-6">
import LiveVideo from './LiveVideo.js'
export default LiveVideo
</script>

<style lang="scss">
@import "LiveVideo";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/liveVideo/LiveVideo.vue